// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"74650246","176":"128d6dd8","180":"cfba6ba5","208":"9b04deff","409":"5ed8aa16","631":"7c70b4b2","774":"5e84fc6e","787":"e7fdae96"}[chunkId] + ".chunk.js";
};